import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_PATH } from '../../api';
import { AuthService } from './auth.service';
import { codificarParametro } from './asociados-listado.service';
import { EstadoRelacion } from './historico-api.service';

export interface RelacionEnEjercicio { idAsociacion: number; nombreAsociacion: string; idCargo: number; cargo: string; estado: EstadoRelacion; }

/** Tarjeta mínima de un asociado en la ficha de Ejercicio: sin NIF, correo, teléfono ni dirección. */
export interface AsociadoEjercicio {
  id: number;
  nombre: string;
  apellidos: string;
  img?: string | null;
  active?: number;
  relaciones: RelacionEnEjercicio[];
  totalRelaciones: number;
}

export interface PaginaAsociadosEjercicio {
  asociados: AsociadoEjercicio[];
  paginacion: { page: number; pageSize: number; total: number; totalPages: number; orden: string; dir: 'asc' | 'desc' };
}

export type EstadoFiltro = 'todos' | 'vigentes' | 'bajas';

export interface ConsultaAsociadosEjercicio {
  page: number;
  pageSize: number;
  q?: string;
  asociacion?: number | null;
  cargo?: number | null;
  tipoAsociacion?: number | null;
  estado?: EstadoFiltro;
  orden?: 'apellidos' | 'nombre';
  dir?: 'asc' | 'desc';
}

export const TAMANOS_PAGINA_EJERCICIO = [12, 24, 48, 96];

/**
 * Asociados de UN ejercicio, paginados desde MySQL (P1.3 Wave 5): GET /ejercicios/{id}/asociados?paginado=true. Nunca se pide la
 * lista completa legacy (~13.000 asociados): solo la página visible, con búsqueda y filtros ejecutados en la API.
 */
@Injectable({ providedIn: 'root' })
export class EjercicioAsociadosService {
  constructor(
    private readonly http: HttpClient,
    private readonly auth: AuthService,
    @Inject(BASE_PATH) private readonly basePath: string
  ) {}

  construirUrl(ejercicio: number, consulta: ConsultaAsociadosEjercicio): string {
    // paginado=true: el contrato paginado es EXPLÍCITO (sin él, la API devuelve la lista completa legacy).
    const partes: [string, string][] = [['paginado', 'true'], ['page', String(consulta.page)], ['pageSize', String(consulta.pageSize)]];
    const q = (consulta.q ?? '').trim();
    if (q) partes.push(['q', q]);
    if (consulta.asociacion) partes.push(['asociacion', String(consulta.asociacion)]);
    if (consulta.cargo) partes.push(['cargo', String(consulta.cargo)]);
    if (consulta.tipoAsociacion !== null && consulta.tipoAsociacion !== undefined) partes.push(['tipoAsociacion', String(consulta.tipoAsociacion)]);
    if (consulta.estado && consulta.estado !== 'todos') partes.push(['estado', consulta.estado]);
    if (consulta.orden && consulta.orden !== 'apellidos') partes.push(['orden', consulta.orden]);
    if (consulta.dir && consulta.dir !== 'asc') partes.push(['dir', consulta.dir]);
    return `${this.basePath}/ejercicios/${ejercicio}/asociados?` + partes.map(([k, v]) => `${k}=${codificarParametro(v)}`).join('&');
  }

  buscar(ejercicio: number, consulta: ConsultaAsociadosEjercicio): Observable<PaginaAsociadosEjercicio> {
    const headers = new HttpHeaders({ Authorization: 'Bearer ' + this.auth.getToken() });
    return this.http.get<PaginaAsociadosEjercicio>(this.construirUrl(ejercicio, consulta), { headers });
  }
}
